export const HexIcon = ({ color }: { color: string }) => {
  return (
    <svg width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M8 2L14.9282 6V14L8 18L1.0718 14V6L8 2Z' stroke={color} strokeWidth='2' />
      </g>
    </svg>
  );
};
